<template>
  <div>
    <h1 class="title">Nächste Schritte und technisches</h1>
    <h2 class="subtitle">Wie es weitergeht und was es dafür brauch</h2>
    <p>
      Sortdesk ist bis jetzt ein Prototyp mit verschiedenen Limitationen. Auch
      die ganze Funktionalität muss sowohl auf Stabilität als auch auf
      Übereinstimmung mit den Nutzen der Endanwender getestet werden.
    </p>
    <br />
    <div class="content">
      <h4 class="is-size-4">Daten, Daten & Daten</h4>
      Der Algorithmus kann nur so gut wie die Qualität der Daten sein. Die
      künstliche Inteliigenz, die hinter Sortdesk steckt, erkennt bis jetzt
      <b>nur 8 Dokumententypen</b>. Für jeden dieser Typen wurde sie auf 369
      Dokumente trainiert. Bis jetzt ist sie somit noch nicht immer präzise. Zur
      Verbesserung brauch es:
      <ul>
        <li>
          <b>Mehr Daten</b>: je grösser und heterogener das Datenvolumen, desto
          präziser wird der Algorithmus
        </li>
        <li>
          <b>Annotierte Daten</b>: beispielsweise Dokumente und die Disziplin,
          zu der sie gehören
        </li>
      </ul>
    </div>
    <br />
    <div class="content">
      <h4 class="is-size-4">Proof of concept</h4>
      <p>
        Das Produkt muss in einem eingerahmten Kontext getestet werden. Dies ist
        der beste Weg um anhand eines <i>Minimum Viable Products</i> mehr über
        die echten Probleme und Bedingungen der Endanwender zu lernen. Wertvolle
        Outputs wären:
      </p>
      <ul>
        <li>Welche <b>Dokumententypen</b> werden eingereicht?</li>
        <li>
          Wie einfach lässt sich das System nutzen bzw. wieviel <b>Zeit</b> wird
          damit <b>gewonnen</b>?
        </li>
        <li>Wie <b>präzise</b> ist die künstliche Intelligenz?</li>
        <li>
          Ist das System <b>stabil</b> bzw. wie lässt sich die Infrastruktur
          <b>scalen</b>?
        </li>
        <li>
          Was sind <b>Anforderungen</b> and die Funktionalität und an den Aufbau
          des Produktes (Business Logic)?
        </li>
      </ul>
    </div>
    <br />
    <div class="content">
      <h4 class="is-size-4">Zeit & Geld</h4>
      <p>
        Während oder nach einem erfolgreichen Proof of concept brauch es
        natürlich <b>Resourcen</b>, um erfolgreich das Projekt weiterzuführen.
        Aus eigener Erfahrung kann ich sagen, dass Projekte nur mit
        <b>vollem Fokus</b>
        abgewickelt werden können. Dies kann natürlich auch in der Form von
        zugewiesenen Tagen entstehen. Ein paar Stunden abends reichen nicht, um
        etwas sinnvolles zu lernen und zu entwickeln.
      </p>
    </div>
    <br />
    <div class="content">
      <h4 class="is-size-4">Offene Punkte</h4>
      <p>Verschiedene Pendenzen, einige wichtig, einige nice-to-have.</p>
      <ul>
        <li>
          Infrastruktur ändern und aufräumen (Prototyp nicht bereit für
          Produktion)
        </li>
        <li>Einreichen der Dokumente <b>per E-Mail</b></li>
        <li>
          <b>Algorithmus verbessern</b> (Hyperparameter und feature engineering)
        </li>
        <li><b>Andere Tags</b> wie Disziplin hinzufügen</li>
        <li><b>Suche</b> hinzufügen</li>
        <li><b>Optical Caracter Recognition</b> einbauen (für "Bild-PDF")</li>
        <li>
          <b
            >Etwas anderes? Schreiben Sie mir:<a
              href="mailto:pierre@sortdesk.com"
              target="_blank"
            >
              pierre@sortdesk.com</a
            ></b
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
